import React from 'react';

const DCFNote: React.FC = () => (
	<div className="flex flex-col gap-1">
		<strong>Notes:</strong>
		<p>
			<strong>a)</strong> The DCF Value (Project) represents the total present value of all expected future cash flows from owning
			the vessel (earnings, costs and eventual sale), discounted using an appropriate Weighted Average Cost of Capital (WACC), as
			defined above. The DCF Value (Equity) is calculated in a similar manner, but focuses solely on the equity portion of the
			investment, based on the loan-to-value (LTV) ratio at the time of purchase.
		</p>
		<p>
			<strong>b)</strong> Average earnings are adjusted on a time-weighted basis to correct for the impact of market cycles in MSI's forecasts - please contact{' '}
			<a href="mailto:sales@msiltd.com" className='text-msi-midblue-color-500'>sales@msiltd.com</a> for info.
		</p>
	</div>
);

export default DCFNote;
